import { render, staticRenderFns } from "./SubmissionTable.vue?vue&type=template&id=19975be4&scoped=true"
import script from "./SubmissionTable.vue?vue&type=script&lang=js"
export * from "./SubmissionTable.vue?vue&type=script&lang=js"
import style0 from "./SubmissionTable.vue?vue&type=style&index=0&id=19975be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19975be4",
  null
  
)

export default component.exports